export default "__VITE_ASSET__27e02846__"